<app-dropdown>
  <div selected class="dropdown-item"
    ><span class="selected-text">{{ selectedSort.displayName }}</span></div
  >
  <div *ngFor="let opt of options" options class="dropdown-item" (click)="selectValue(opt)"
    ><span class="dropdown-text" i18n>{{ opt.displayName }}</span></div
  >
</app-dropdown>
